import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as reducer from './time-card.reducer';

const localState = createFeatureSelector<reducer.State>(
    reducer.timeCardsFeatureKey
);
export const getEntities = createSelector(localState, x => x.entities);
export const { selectAll, selectEntities, selectIds, selectTotal } =
    reducer.adapter.getSelectors(localState);
